import { observable, action } from "mobx";

export default class Test {
  @observable test = "test";

  @action
  changeTest(str) {
    // console.log('changeLoading', state)
    this.test = str;
  }
}



// WEBPACK FOOTER //
// ./src/store/test.js